import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function auctionReducer() {
  return combineReducers({
    auctionList: createItemReducer("CarrierHome", "TenderDocumentRelsWeb.ListLot", false),
    auctionListParams: createItemReducerParams("CarrierHome", "TenderDocumentRelsWeb.ListLot"),
    auctionListUA: createItemReducer("CarrierHome", "TenderDocumentRelsWeb.ListLotUA", false),
    auctionListUAParams: createItemReducerParams("CarrierHome", "TenderDocumentRelsWeb.ListLotUA"),
    auctionAcceptItem: createItemReducer("CarrierHome", "TenderDocumentRelsCompanyWeb.Insert", false),
    auctionRefuseItem: createItemReducer("CarrierHome", "TenderDocumentRelsCompanyWeb.Delete", false),
    auctionStakesRefresh: createItemReducer("CarrierHome", "TenderDocumentRels.ListLotRefresh", false),
    auctionStakesRefreshUA: createItemReducer("CarrierHome", "TenderDocumentRels.ListLotRefreshUA", false),
    auctionInformerItem: createItemReducer("CarrierHome", "TenderDocumentRelsWeb.GetInformerData", false),
    routeDetailsItem: createItemReducer("CarrierHome", "TruckPlanDistributionLogWeb.ListTD/AuctionRouteDetails", false)
  });
}